/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import {
  AppBar,
  Box,
  Button,
  Checkbox,
  Dialog,
  FormControlLabel,
  IconButton,
  Slide,
  Tab,
  Tabs,
  TextField,
  Toolbar,
  Typography,
} from "@mui/material";
import { cloneElement, forwardRef, useEffect, useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import CenterSelect from "./CenterSelect";
import WhatsNewMapping from "./WhatsNewMapping";
import WhatsNewPopupMaker from "./WhatsNewPopupMaker";
import axios from "axios";
import clone_object from "../lib/clone_object";
import Swal from "sweetalert2";

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const WhatsNewModal = forwardRef(({ children, loadData, login }, ref) => {
  const [open, setOpen] = useState(false);
  const [id, setId] = useState();
  const init = {
    cid: "",
    title: "",
    sub_text: "",
    popup_yn: "N",
    sdate: "",
    edate: "",
    menu_img: {},
    body_img: {},
    popup_img: {},
    meta_popup: {
      color: "#ffffff",
      background: "#3859ff",
    },
    meta_bodyimg: [],
  };
  const [data, setData] = useState(init);
  const [tab, setTab] = useState(0);
  const modlaOpen = (id) => {
    setOpen(true);
    setId(id);
  };
  const modalClose = () => {
    setOpen(false);
    loadData();
    setTimeout(() => {
      setId();
      setData(init);
      setTab(0);
    }, 250);
  };
  ref.current = (id) => modlaOpen(id);

  useEffect(() => {
    if (!id || id === "add") return;
    const getData = async () => {
      const result = await axios.post(
        `${process.env.REACT_APP_API}/gympass_admin/whatsnew_one`,
        {
          token: localStorage.getItem("token"),
          level: login.level,
          mcd: login.mcd,
          id,
        }
      );
      if (!result?.data?.success) return Swal.fire(result.data.msg);
      setData(result.data.row);
    };
    getData();
  }, [id]);

  const onChange = (e) =>
    setData((state) => {
      const copy = { ...state };
      copy[e.target.name] = e.target.value;
      return copy;
    });

  const imgUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    const src = await new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = ({ target }) => {
        resolve(target.result);
      };
      reader.readAsDataURL(file);
    });
    setData((state) => {
      const copy = clone_object(state);
      copy[e.target.name] = {
        src,
        file,
      };
      return copy;
    });
  };

  const submit = async () => {
    const obj = {
      ...data,
      token: localStorage.getItem("token"),
      level: login.level,
      mcd: login.mcd,
      id,
    };
    const form = new FormData();
    for (let key in obj) {
      if (key.includes("_img") && obj[key]) {
        form.append(key, obj[key].file);
      } else if (key.includes("meta"))
        form.append(key, JSON.stringify(obj[key]));
      else form.append(key, obj[key]);
    }
    const result = await axios.post(
      `${process.env.REACT_APP_API}/gympass_admin/whatsnew_add`,
      form
    );
    if (!result?.data?.success) return Swal.fire(result.data.msg);
    modalClose();
  };

  const del = async () => {
    const result = await axios.post(
      `${process.env.REACT_APP_API}/gympass_admin/whatsnew_delete`,
      {
        token: localStorage.getItem("token"),
        level: login.level,
        mcd: login.mcd,
        id,
      }
    );
    if (!result?.data?.success) return Swal.fire(result.data.msg);
    modalClose();
  };

  return (
    <>
      <Dialog
        TransitionComponent={Transition}
        open={open}
        onClose={modalClose}
        maxWidth="md"
        fullWidth
      >
        <AppBar sx={{ position: "static" }}>
          <Toolbar>
            <Box sx={{ flexGrow: 1 }}>
              <Typography style={{ fontSize: 18 }}>
                FC 업무 보고서 {id === "add" ? "추가" : "수정"}
              </Typography>
            </Box>
            <IconButton
              edge="start"
              color="inherit"
              onClick={modalClose}
              aria-label="close"
            >
              <CloseIcon />
            </IconButton>
          </Toolbar>
        </AppBar>

        {/* 본문 입력 폼 */}
        <section
          css={css`
            padding: 1rem;
            display: flex;
            flex-direction: column;
            gap: 0.5rem;
            align-items: start;
          `}
        >
          {/* 센터 선택 */}
          <CenterSelect
            login={login}
            tcidParent={data.tcid}
            setTcidParent={(e) =>
              onChange({ target: { name: "cid", value: e } })
            }
          />
          {/* 미리보기 */}
          <article
            css={css`
              display: flex;
              gap: 1rem;
              align-items: end;
            `}
          >
            <div
              css={css`
                border: 1px solid lightgray;
                padding: 0.5rem;
                border-radius: 7px;
                width: 300px;
              `}
            >
              <span>미리보기</span>
              <div
                css={css`
                  height: 150px;
                  border-radius: 5px;
                  margin-bottom: 5px;
                `}
              >
                <img
                  src={data.menu_img.src}
                  alt=""
                  css={css`
                    object-fit: contain;
                    height: 100%;
                  `}
                />
              </div>
              <span
                css={css`
                  display: block;
                  font-weight: 700;
                  font-size: 18px;
                `}
              >
                {data.title}
              </span>
              <span
                css={css`
                  display: block;
                  font-size: 14px;
                  width: 270px;
                  font-weight: 300;
                `}
              >
                {data.sub_text}
              </span>
            </div>
            {/* 메뉴 이미지 업로드 */}
            <div>
              <span>메뉴 이미지</span> <br />
              <input
                type="file"
                name="menu_img"
                onChange={imgUpload}
                accept="image/*"
              />
            </div>
          </article>
          {/* 타이틀 */}
          <TextField
            label="타이틀"
            placeholder="타이틀"
            size="small"
            sx={css`
              width: 100%;
            `}
            value={data.title}
            name="title"
            onChange={onChange}
          />
          {/* 서브텍스트 */}
          <TextField
            label="서브타이틀"
            placeholder="서브타이틀"
            size="small"
            sx={css`
              width: 100%;
            `}
            value={data.sub_text}
            name="sub_text"
            onChange={onChange}
          />
          {/* 날짜 입력 */}
          <article
            css={css`
              display: flex;
              gap: 0.5rem;
              width: 100%;
            `}
          >
            <TextField
              label="시작 날짜"
              placeholder="YYYY-MM-DD"
              size="small"
              sx={css`
                width: 100%;
              `}
              value={data.sdate}
              name="sdate"
              onChange={onChange}
            />
            <TextField
              label="종료 날짜"
              placeholder="YYYY-MM-DD"
              size="small"
              sx={css`
                width: 100%;
              `}
              value={data.edate}
              name="edate"
              onChange={onChange}
            />
          </article>
          <FormControlLabel
            control={<Checkbox />}
            label="팝업 사용"
            onChange={(e) => {
              onChange({
                target: {
                  name: "popup_yn",
                  value: e.target.checked ? "Y" : "N",
                },
              });
              setTab(0);
            }}
            checked={data.popup_yn === "Y"}
          />
        </section>

        {/* 본문 및 팝업 이미지 */}
        <section>
          <Tabs
            onChange={(e) => setTab(+e.target.attributes.id.value)}
            value={tab}
            sx={css`
              border-bottom: 1px solid lightgrey;
            `}
          >
            <Tab label="분문" id="0" />
            {data.popup_yn === "Y" && <Tab label="팝업" id="1" />}
          </Tabs>
          <article
            css={css`
              padding: 0.5rem;
              box-sizing: border-box;
            `}
          >
            {tab === 0 && (
              <WhatsNewMapping
                data={data}
                setData={setData}
                imgUpload={imgUpload}
              />
            )}
            {tab === 1 && (
              <WhatsNewPopupMaker
                data={data}
                setData={setData}
                imgUpload={imgUpload}
              />
            )}
          </article>
        </section>

        <section
          css={css`
            display: flex;
            gap: 0.5rem;
            justify-content: center;
            padding: 1rem 0;
          `}
        >
          <Button variant="contained" onClick={submit}>
            저장
          </Button>
          {id !== "add" && (
            <Button variant="contained" color="error" onClick={del}>
              삭제
            </Button>
          )}
          <Button variant="contained" color="warning" onClick={modalClose}>
            닫기
          </Button>
        </section>
      </Dialog>

      {cloneElement(children, { onClick: () => modlaOpen("add") })}
    </>
  );
});

export default WhatsNewModal;
